var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import zipObj from 'ramda/src/zipObj';
import { Box } from '../Box';
import { Space } from '../Space';
import { useMediaSize } from '../tools/utils';
import { muiBankTheme } from '../tools/theme';
var styledSystemBreakpoints = [
    'default',
    'sm',
    'md',
    'lg',
];
var getAlignment = function (align) {
    switch (align) {
        case 'center':
            return 'center';
        case 'right':
            return 'flex-end';
        default:
            return 'flex-start';
    }
};
var getVerticalAlignment = function (alignVertical) {
    switch (alignVertical) {
        case 'center':
            return 'center';
        case 'bottom':
            return 'flex-end';
        default:
            return 'flex-start';
    }
};
var OuterBox = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var marginValues = _a.marginValues, media = _a.theme.media;
    return "\n    &:before {\n      display: block;\n      content: '';\n    }\n\n    ".concat(media.up('sm'), " {\n      &:before {\n        margin-top: ").concat(marginValues.sm, ";\n      }\n    }\n\n    ").concat(media.up('md'), " {\n      &:before {\n        margin-top: ").concat(marginValues.md, ";\n      }\n    }\n\n    ").concat(media.up('lg'), " {\n      &:before {\n        margin-top: ").concat(marginValues.lg, ";\n      }\n    }\n  ");
});
var getFlexDirection = function (reverse, isRowMode) {
    var rowOrColumn = isRowMode ? 'row' : 'column';
    return "flex-direction: ".concat(reverse ? "".concat(rowOrColumn, "-reverse") : rowOrColumn, ";");
};
/**
 * Generates the style 'flex-direction: row|column[-reversed]'
 */
var BreakpointInline = styled(Box).attrs(function (props) { return ({
    reverse: props.reverse || false,
    isRowMode: props.isRowMode,
}); })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  ", "\n"], ["\n  display: flex;\n  ", "\n"])), function (_a) {
    var reverse = _a.reverse, isRowMode = _a.isRowMode;
    return getFlexDirection(reverse, isRowMode);
});
var themeSpace = muiBankTheme.space;
/**
 * Convert a number to a negative pixel value, ie 4 ==> '-4px'
 */
var toNegativePixelString = function (num) { return "-".concat(num, "px"); };
/**
 * Given a spacing string value (ie, 'md') return a pixel value from the theme (ie, '24px')
 */
var toThemeNumber = function (spaceVal) {
    return parseInt(themeSpace[spaceVal], 10);
};
var Inline = function (_a) {
    var children = _a.children, space = _a.space, spaceColumn = _a.spaceColumn, align = _a.align, alignVertical = _a.alignVertical, reverse = _a.reverse, className = _a.className, breakpointWidth = _a.breakpointWidth;
    var _b = __read(useState(false), 2), isRowMode = _b[0], setRowMode = _b[1];
    var isSmDown = useMediaSize('SmDown');
    var isMdOnly = useMediaSize('MdOnly');
    var isLgUp = useMediaSize('LgUp');
    useEffect(function () {
        switch (breakpointWidth) {
            case 'sm':
                setRowMode(!isSmDown);
                break;
            case 'md':
                setRowMode(!(isMdOnly || isSmDown));
                break;
            case 'lg':
                setRowMode(isLgUp);
                break;
            default:
                setRowMode(true);
                break;
        }
    }, [isSmDown, isMdOnly, isLgUp, breakpointWidth, isRowMode]);
    var spaceArray = Array.isArray(space) ? space : [space, space, space, space];
    var negativeTopPixels = spaceArray
        .map(toThemeNumber)
        .map(function (number) { return number + 1; })
        .map(toNegativePixelString);
    var negativePixelMap = zipObj(styledSystemBreakpoints, negativeTopPixels);
    var negativePixelValues = spaceArray.map(function (sp) {
        var pxValue = themeSpace[sp];
        return "-".concat(pxValue);
    });
    var filteredChildren = React.Children.toArray(children).filter(Boolean);
    return (React.createElement(OuterBox, { marginValues: negativePixelMap, pt: "1px" },
        React.createElement(BreakpointInline, __assign({ ml: negativePixelValues, display: "flex", isRowMode: isRowMode, reverse: reverse, flexWrap: "wrap", className: className, "data-testid": "mui-inline-container" }, (align && { justifyContent: getAlignment(align) }), (alignVertical && {
            alignItems: getVerticalAlignment(alignVertical),
        })), React.Children.map(filteredChildren, function (child) {
            return (React.createElement(Space, { mt: isRowMode ? space : spaceColumn, ml: isRowMode ? space : spaceColumn }, child));
        }))));
};
export { Inline };
var templateObject_1, templateObject_2;
//# sourceMappingURL=Inline.js.map